var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.347 5.833c0-2.333 1.84-4.166 4.183-4.166s4.183 1.833 4.183 4.166C11.713 8.167 9.873 10 7.53 10S3.347 8.167 3.347 5.833zm11.713 10V17.5c0 .5-.335.833-.837.833s-.837-.333-.837-.833v-1.667c0-1.416-1.087-2.5-2.51-2.5H4.184c-1.422 0-2.51 1.084-2.51 2.5V17.5c0 .5-.334.833-.836.833S0 18 0 17.5v-1.667c0-2.333 1.84-4.166 4.183-4.166h6.694c2.342 0 4.183 1.833 4.183 4.166zm-7.53-7.5c-1.422 0-2.51-1.083-2.51-2.5 0-1.416 1.088-2.5 2.51-2.5 1.422 0 2.51 1.084 2.51 2.5 0 1.417-1.088 2.5-2.51 2.5zm9.37 3.5c-.418-.083-.92.167-1.004.584-.083.416.168.916.586 1 1.088.25 1.84 1.25 1.84 2.416V17.5c0 .5.335.833.837.833s.837-.333.837-.833v-1.667c.084-1.916-1.171-3.583-3.096-4zm-4.35-9.416c.167-.5.585-.75 1.004-.584 2.259.5 3.597 2.834 3.012 5.167-.335 1.5-1.506 2.583-3.012 3h-.168c-.418 0-.752-.25-.836-.667-.168-.416.167-.916.585-1 .92-.25 1.59-.916 1.841-1.833.335-1.417-.502-2.75-1.84-3.083-.419-.084-.67-.584-.586-1z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0qolhg4woa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.347 5.833c0-2.333 1.84-4.166 4.183-4.166s4.183 1.833 4.183 4.166C11.713 8.167 9.873 10 7.53 10S3.347 8.167 3.347 5.833zm11.713 10V17.5c0 .5-.335.833-.837.833s-.837-.333-.837-.833v-1.667c0-1.416-1.087-2.5-2.51-2.5H4.184c-1.422 0-2.51 1.084-2.51 2.5V17.5c0 .5-.334.833-.836.833S0 18 0 17.5v-1.667c0-2.333 1.84-4.166 4.183-4.166h6.694c2.342 0 4.183 1.833 4.183 4.166zm-7.53-7.5c-1.422 0-2.51-1.083-2.51-2.5 0-1.416 1.088-2.5 2.51-2.5 1.422 0 2.51 1.084 2.51 2.5 0 1.417-1.088 2.5-2.51 2.5zm9.37 3.5c-.418-.083-.92.167-1.004.584-.083.416.168.916.586 1 1.088.25 1.84 1.25 1.84 2.416V17.5c0 .5.335.833.837.833s.837-.333.837-.833v-1.667c.084-1.916-1.171-3.583-3.096-4zm-4.35-9.416c.167-.5.585-.75 1.004-.584 2.259.5 3.597 2.834 3.012 5.167-.335 1.5-1.506 2.583-3.012 3h-.168c-.418 0-.752-.25-.836-.667-.168-.416.167-.916.585-1 .92-.25 1.59-.916 1.841-1.833.335-1.417-.502-2.75-1.84-3.083-.419-.084-.67-.584-.586-1z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0qolhg4woa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.5282854a221eaaf5167062a418e2ae83.svg";
export { ForwardRef as ReactComponent };